import React from 'react';
import './styles.scss';
import { Link, useNavigate, useParams } from 'react-router-dom';
import RiderResultTable from './rider-result-table';
import UserResultTable from './user-result-table';
import { ReactComponent as BackIcon } from 'assets/icons//back.svg';
import { ENUM_SEARCH_KEY } from 'utils/enum';
import OrderResultSideModal from './order-result-list';
import { ROUTE_KEYS } from 'utils/constants';
const SearchResult = () => {
  const { filterType } = useParams();
  const navigate = useNavigate();
  if (!filterType) navigate(-1);

  return (
    <div>
      <p className='font-medium text-xl pb-1'>
        Showing
        {filterType === ENUM_SEARCH_KEY.RIDER_NAME
          ? ' rider '
          : filterType === ENUM_SEARCH_KEY.ORDER_CODE
          ? ' order '
          : ' user '}
        search results
      </p>

      <Link
        to={ROUTE_KEYS.SEARCH}
        className='inline-flex justify-start gap-1 items-center text-[#595959] font-xs mb-10 cursor-pointer'>
        <BackIcon /> Back to search
      </Link>
      {filterType === ENUM_SEARCH_KEY.RIDER_NAME ? (
        <RiderResultTable />
      ) : filterType === ENUM_SEARCH_KEY.ORDER_CODE ? (
        <OrderResultSideModal />
      ) : (
        <UserResultTable />
      )}
    </div>
  );
};

export default SearchResult;
